import React from "react";
import { useNavigate } from "react-router-dom";
import "../../style/TopArtistView.css";
function TopArtistGridView() {
  const navigate = useNavigate();

  const artist = [
    {
      profileImg: "Screen Shot 2021-12-21 at 12.37 8.png",
      profileName: "Bubblegoose",
      followers: "55 Followers",
    },
    {
      profileImg: "Screen Shot 2021-12-21 at 12.37 9.png",
      profileName: "DeGods",
      followers: " 24 Followers",
    },
    {
      profileImg: "Screen Shot 2021-12-21 at 12.38 8.png",
      profileName: "ApeYachtClub",
      followers: " 32 Followers",
    },
    {
      profileImg: "Screen Shot 2021-12-21 at 12.38 9.png",
      profileName: "Midnight Panthers",
      followers: " 54 Followers",
    },
  ];

  const CollectionDetail = (e) => {
    navigate("/artist-collection", { state: { id: e } });
    // console.log(e)
  };

  return (
    <div className="artistGrid">
      {Array(4)
        .fill(artist)
        .flat()
        .sort(() => 0.5 - Math.random())
        .map((e, index) => {
          return (
            <div
              className="artistCard"
              key={index}
              onClick={() => CollectionDetail(e)}
            >
              <div className="position-relative d-flex flex-column align-items-center justify-content-center">
                <div className="bgProfile"></div>
                <div className="profileHandler">
                  <img
                    src={e.profileImg}
                    alt="profile"
                    className="userprofile"
                  />
                  <img src="signed 1.png" alt="tick" className="profileTick" />
                </div>
                <div className="textHandler">
                  <h5>{e.profileName}</h5>
                  <p>{e.followers}</p>
                </div>
              </div>
            </div>
          );
        })}
      {/* <div className="artistCard">
        <div className="position-relative d-flex flex-column align-items-center justify-content-center">
          <div className="bgProfile"></div>
          <div className="profileHandler">
            <img
              src="Screen Shot 2021-12-21 at 12.37 8.png"
              alt="profile"
              className="userprofile"
            />
            <img src="signed 1.png" alt="tick" className="profileTick" />
          </div>
          <div className="textHandler">
            <h5>Bubblegoose</h5>
            <p>55 Followers</p>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default TopArtistGridView;
